import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GuestCheckData } from '@shared/modals/guest-check-modal/shared/guest-check-data';
import { GuestCheckModalStoreService } from '@shared/modals/guest-check-modal/shared/guest-check-modal-store.service';
import { ModalContainerComponent } from '@shared/ui-components/modal-container/modal-container.component';

@Component({
  selector: 'evland-guest-check-modal',
  imports: [
    ModalContainerComponent,
  ],
  templateUrl: './guest-check-modal.component.html',
  styleUrl: './guest-check-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GuestCheckModalComponent {
  data: Signal<GuestCheckData>;

  private activeModal = inject(NgbActiveModal);
  private guestCheckModal = inject(GuestCheckModalStoreService);

  constructor() {
    this.initData();
  }

  onClose(): void {
    this.activeModal.close();
  }

  onGuestClick(): void {
    this.activeModal.close('guest');
  }

  onSignInClick(): void {
    this.activeModal.close('signIn');
  }

  private initData(): void {
    this.data = this.guestCheckModal.currentS;
  }
}
